import uiTeamSelector from './teamSelector/team-selector.vue'
import uiSponsorSelector from './sponsorSelector/index.vue'
import uiDealSelector from './dealSelector/index.vue'

export {
	uiSponsorSelector,
	uiDealSelector,
	uiTeamSelector
}